export const mapToPromotionCard = (promo: Queries.node__promotion) => {
	return {
		priority: 0,
		title: promo.field_title_front_end,
		body: promo.field_text,
		buttonLabel: promo.field_promo_link.title,
		buttonUrl: promo.field_promo_link.uri,
		promotionType: promo.relationships.field_promotion_type.name,
		imgSrc:
			promo.relationships?.field_promo_image?.field_media_image?.uri || "",
	} as DogsTrust.PromotionCardToDisplayProps;
};
